import { render, staticRenderFns } from "./AutoawardList.vue?vue&type=template&id=2b0772b4&"
import script from "./AutoawardList.vue?vue&type=script&lang=js&"
export * from "./AutoawardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports